import sales from './sales';



export default [
    sales
];
